/* AVE REX — minimal theme behaviour. No dependencies. */
(function () {
  'use strict';

  /* ---------- mobile nav drawer ---------- */
  function initDrawer() {
    var burger = document.querySelector('[data-drawer-toggle]');
    var drawer = document.querySelector('[data-drawer]');
    if (!burger || !drawer) return;

    burger.addEventListener('click', function () {
      var open = drawer.getAttribute('data-open') === 'true';
      drawer.setAttribute('data-open', open ? 'false' : 'true');
      burger.setAttribute('aria-expanded', open ? 'false' : 'true');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawer.getAttribute('data-open') !== 'true') return;
      drawer.setAttribute('data-open', 'false');
      burger.setAttribute('aria-expanded', 'false');
      burger.focus();
    });
  }

  /* ---------- product card colour dots ----------
     Clicking a swatch swaps the card image to that variant's
     photo without leaving the grid. */
  function initCardSwatches() {
    document.querySelectorAll('[data-card-dots]').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var dot = e.target.closest('.dot');
        if (!dot) return;
        e.preventDefault();

        group.querySelectorAll('.dot').forEach(function (d) {
          d.setAttribute('aria-pressed', 'false');
        });
        dot.setAttribute('aria-pressed', 'true');

        var card = group.closest('.card');
        var img = card && card.querySelector('[data-card-image]');
        var src = dot.getAttribute('data-image');
        if (img && src) {
          img.setAttribute('src', src);
          img.removeAttribute('srcset');
          img.setAttribute('alt', dot.getAttribute('data-alt') || img.alt);
        }

        var link = card && card.querySelector('[data-card-link]');
        var url = dot.getAttribute('data-url');
        if (link && url) link.setAttribute('href', url);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDrawer();
      initCardSwatches();
    });
  } else {
    initDrawer();
    initCardSwatches();
  }
})();
